import React, { useState } from "react";
import "../Styles/Ourclub.css";
import JoinModal from "../components/JoinModel";

const A = "/assets/";

const CLUBS = [
  {
    id: "elite",
    theme: "orange",
    number: "01",
    title: "Elite HR Circle",
    subtitle: "A distinguished community for HR leaders shaping the future of Work.",
    tag: "A COMMUNITY FOR THOSE WHO SHAPE THE FUTURE OF WORK",
    desc:
      "The Elite HR Circle by Vanakkam HRD brings together senior human resources leaders who influence organizational strategy, culture, talent and business performance. Our community is designed to encourage meaningful peer connections, confidential knowledge exchange, leadership conversations and collaboration among experienced HR professionals.",
    cards: [
      {
        type: "list",
        icon: "OC_1st_card_Icon_1.png",
        iconBg: "navy",
        title: "Who Can Apply?",
        bullet: "OC_1st_card_Icon_4.png",
        items: [
          "CHROs and Chief People Officers",
          "HR Heads and HR Directors",
          "Vice Presidents of Human Resources",
          "Senior HR Business Partners",
          "Experienced people and organizational leaders",
        ],
      },
      {
        type: "list",
        highlight: true,
        icon: "OC_1st_card_Icon_2.png",
        iconBg: "orange",
        title: "Membership Benefits",
        bullet: "OC_1st_card_Icon_5.png",
        items: [
          "Invitations to curated HR leadership discussions and roundtables",
          "Networking opportunities with senior HR professionals",
          "Access to relevant leadership forums and knowledge-sharing sessions",
          "Opportunities to contribute as speakers, mentors and industry experts",
          "Connections with business leaders and professional communities",
        ],
      },
      {
        type: "chips",
        icon: "OC_1st_card_Icon_3.png",
        iconBg: "navy",
        title: "Our Focus Areas",
        items: [
          "Strategic HR",
          "Org Transformation",
          "Leadership",
          "Talent Strategy",
          "Employee Experience",
          "AI in HR",
          "Workforce Planning",
          "Future of Work",
        ],
      },
    ],
  },
  {
    id: "future",
    theme: "orange",
    number: "02",
    title: "Future Leaders Club",
    subtitle: null,
    tag: "BUILDING THE LEADERS OF TOMORROW",
    desc:
      "The Future Leaders Club by Vanakkam HRD is a professional development community for ambitious individuals who want to strengthen their leadership capabilities, expand their professional network and prepare for the next stage of their careers. We bring together emerging leaders, HR professionals, young managers and aspiring executives who believe in continuous learning and meaningful collaboration.",
    cards: [
      {
        type: "list",
        icon: "OC_2nd_card_Icon_1.png",
        iconBg: "navy",
        title: "Who Can Join?",
        bullet: "OC_1st_card_Icon_4.png",
        items: [
          "Emerging HR leaders and HR professionals",
          "Executives, team leaders and managers",
          "Aspiring business leaders and entrepreneurs",
          "Young professionals seeking career development",
          "Students and fresh graduates interested in leadership",
        ],
      },
      {
        type: "list",
        highlight: true,
        icon: "OC_2nd_card_Icon_2.png",
        iconBg: "orange",
        title: "What You Can Explore",
        bullet: "OC_2nd_card_Icon_4.png",
        items: [
          "Leadership and professional development programs",
          "Mentoring and career guidance opportunities",
          "HR workshops, masterclasses and industry sessions",
          "Networking with experienced professionals",
          "Opportunities to participate in events and community initiatives",
          "Learning in HR technology, analytics and future workplace trends",
        ],
      },
      {
        type: "quote",
        icon: "OC_2nd_card_Icon_3.png",
        title: "Our Mission",
        quote:
          "“To help professionals build the knowledge, confidence, relationships and practical skills needed to become effective future leaders.”",
      },
    ],
  },
  {
    id: "edu",
    theme: "blue",
    number: "03",
    title: "Educational Club",
    subtitle: null,
    tag: "CONNECTING EDUCATION, TALENT AND INDUSTRY",
    desc:
      "The Educational Club by Vanakkam HRD is a collaborative platform for educational institutions, academic leaders, faculty members, placement officers and industry professionals. Our objective is to strengthen academia–industry relationships, support student employability and create opportunities for knowledge exchange, industry engagement and career readiness.",
    cards: [
      {
        type: "list",
        icon: "OC_3rd_card_Icon_1.png",
        iconBg: "navy",
        title: "Who Can Join?",
        bullet: "OC_1st_card_Icon_4.png",
        items: [
          "Colleges and universities",
          "Educational institution management",
          "Placement and training officers",
          "Faculty members and department heads",
          "Career development and employability teams",
          "Academic and industry partnership professionals",
        ],
      },
      {
        type: "list",
        highlight: true,
        icon: "OC_3rd_card_Icon_2.png",
        iconBg: "orange",
        title: "Our Initiatives",
        bullets: [
          "OC_3rd_card_Icon_4.png",
          "OC_3rd_card_Icon_5.png",
          "OC_3rd_card_Icon_6.png",
          "OC_3rd_card_Icon_7.png",
          "OC_3rd_card_Icon_8.png",
          "OC_3rd_card_Icon_9.png",
        ],
        items: [
          "Campus-to-corporate and industry interaction programs",
          "HR and industry leadership talks",
          "Employability and career readiness workshops",
          "Internship and placement collaboration opportunities",
          "Faculty development and knowledge-sharing sessions",
          "Industry–academia conclaves and networking events",
        ],
      },
      {
        type: "quote",
        icon: "OC_3rd_card_Icon_3.png",
        title: "Our Vision",
        quote:
          "“To build a stronger connection between academic learning and industry expectations, helping institutions prepare students for meaningful careers.”",
      },
    ],
  },

  /* ================= Section 5 (club 04) - Founders Club ================= */
  {
    id: "club4",
    theme: "orange",
    number: "04",
    title: "Founders Club",
    subtitle: null,
    tag: "A COMMUNITY FOR BUILDERS, INNOVATORS AND ENTREPRENEURS",
    desc:
      "The Founders Club by Vanakkam HRD is designed for entrepreneurs, startup founders, co-founders and business owners who want to build meaningful relationships, exchange practical insights and explore opportunities for business growth. We believe entrepreneurship becomes stronger when people share experiences, learn from one another and collaborate across industries.",
    cards: [
      {
        type: "list",
        icon: "OC_4th_card_Icon_1.png",
        iconBg: "navy",
        title: "Who Can Join?",
        bullet: "OC_1st_card_Icon_4.png",
        items: [
          "Startup founders and co-founders",
          "Entrepreneurs and business owners",
          "CEOs and business leaders",
          "Early-stage and growth-stage startup teams",
          "Founders building technology, services or people-focused businesses",
        ],
      },
      {
        type: "list",
        highlight: true,
        icon: "OC_4th_card_Icon_2.png",
        iconBg: "orange",
        title: "What the Community Offers",
        bullet: "OC_4th_card_Icon_4.png",
        items: [
          "Founder-to-founder networking",
          "Business and leadership knowledge-sharing sessions",
          "Opportunities to explore strategic partnerships",
          "Discussions on talent, team building and organizational growth",
          "Connections with HR leaders, consultants and educational institutions",
          "Opportunities to participate in business forums and community events",
        ],
      },
      {
        type: "chips",
        icon: "OC_4th_card_Icon_3.png",
        iconBg: "navy",
        title: "Our Focus Areas",
        items: [
          "Entrepreneurship",
          "Talent Strategy",
          "Startup Culture",
          "Leadership",
          "Scaling Teams",
          "Business Operations",
          "Innovation",
          "Sustainable Growth",
        ],
      },
    ],
  },

  /* ================= Section 6 (club 05) - Consultants & Advisory Club ================= */
  {
    id: "club5",
    theme: "blue",
    number: "05",
    title: "Consultants & Advisory Club",
    subtitle: null,
    tag: "CONNECTING EXPERTISE WITH OPPORTUNITY",
    desc:
      "The Consultants & Advisory Club by Vanakkam HRD is a professional network for independent consultants, HR advisors, management consultants, trainers, coaches and industry specialists. The club encourages knowledge exchange, professional collaboration and meaningful connections between experts and organizations seeking practical insights.",
    cards: [
      {
        type: "list",
        icon: "OC_5th_card_Icon_1.png",
        iconBg: "navy",
        title: "Who Can Join?",
        bullet: "OC_1st_card_Icon_4.png",
        items: [
          "Independent HR and management consultants",
          "HR strategy and organizational development advisors",
          "Talent acquisition and workforce consultants",
          "Learning and leadership development professionals",
          "HR technology and people analytics specialists",
          "Trainers, coaches and industry subject-matter experts",
        ],
      },
      {
        type: "list",
        highlight: true,
        icon: "OC_5th_card_Icon_1.png", // as given by you (Icon_1). Change to Icon_2 if that was a typo
        iconBg: "orange",
        title: "Membership Opportunities",
        bullets: [
          "OC_5th_card_Icon_4.png",
          "OC_5th_card_Icon_5.png",
          "OC_5th_card_Icon_6.png",
          "OC_5th_card_Icon_7.png",
          "OC_5th_card_Icon_8.png",
          "OC_5th_card_Icon_9.png",
        ],
        items: [
          "Connect with business leaders and HR decision-makers",
          "Share professional insights through articles and knowledge sessions",
          "Explore speaking, mentoring and workshop opportunities",
          "Participate in expert discussions and industry forums",
          "Build relationships with other consultants and service providers",
          "Explore relevant partnership and collaboration opportunities",
        ],
      },
      {
        type: "chips",
        icon: "OC_5th_card_Icon_3.png",
        iconBg: "navy",
        title: "Areas of Expertise",
        chipsWideFrom: 6,
        items: [
          "HR Strategy",
          "Recruitment",
          "HR Technology",
          "People Analytics",
          "Compliance",
          "Leadership",
          "Learning & Development",
          "Organizational Development",
          "Compensation & Benefits",
          "Workplace Transformation",
        ],
      },
    ],
  },
];

/* ================= Section 7 - Our Club Presence ================= */
const PRESENCE = {
  tag: "OUR CLUB PRESENCE",
  title: "Building Connections. Empowering Leaders. Across India.",
  desc:
    "Our professional clubs bring together HR leaders, emerging professionals, educators, founders, and industry experts to connect, collaborate, and grow through a strong professional network.",
  icon: "OC_7th_card_Icon_1.png",
  cards: [
    {
      title: "North India",
      count: "4 Locations",
      places: "Delhi, Gurgaon, Noida, Faridabad",
    },
    {
      title: "West India", // image-la "Weest India" nu typo irukku; ingae correct spelling
      count: "2 Locations",
      places: "Mumbai, Pune",
    },
    {
      title: "South India",
      count: "3 Locations",
      places: "Bengaluru, Hyderabad, Chennai",
    },
    {
      title: "Pan-India Reach",
      count: "9 Cities",
      places: "Talent, Technology, Nationwide connections.",
      dark: true,
    },
  ],
};

/* India map image - extracted from the reference image (SVG coordinate space 656 x 712) */
const INDIA_MAP_IMG = "OC_India_Map.png";

/* City points - positions, label boxes and connector lines taken from the reference image */
const MAP_CITIES = [
  {
    name: "NCR",
    dot: [339.5, 264],
    box: { x: 408, y: 185, w: 69, h: 37 },
    line: [[408, 203], [378, 203], [378, 264]],
    delay: 0,
  },
  {
    name: "Mumbai",
    dot: [267, 398],
    box: { x: 13, y: 318, w: 113, h: 38 },
    line: [[126, 337], [209, 337], [209, 369], [267, 369]],
    delay: 0.35,
  },
  {
    name: "Pune",
    dot: [270.5, 417],
    box: { x: 130, y: 397, w: 78, h: 38 },
    line: [[208, 416]],
    delay: 0.7,
  },
  {
    name: "Hyderabad",
    dot: [381.5, 436],
    box: { x: 505, y: 415, w: 140, h: 38 },
    line: [[505, 436]],
    delay: 1.05,
  },
  {
    name: "Bengaluru",
    dot: [327.5, 510],
    box: { x: 38, y: 490, w: 136, h: 38 },
    line: [[174, 510]],
    delay: 1.4,
  },
  {
    name: "Chennai",
    dot: [378, 520.5],
    box: { x: 525, y: 499, w: 119, h: 37 },
    line: [[525, 519]],
    delay: 1.75,
  },
];

const IndiaMap = () => (
  <svg
    className="oc-map-svg"
    viewBox="0 0 656 712"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="India map showing club locations"
  >
    <image
      href={`${A}${INDIA_MAP_IMG}`}
      x="0"
      y="0"
      width="656"
      height="712"
      preserveAspectRatio="xMidYMid meet"
    />

    {MAP_CITIES.map((c) => {
      const [dx, dy] = c.dot;
      const pts = [...c.line, c.dot].map((p) => p.join(",")).join(" ");
      return (
        <g key={c.name}>
          <polyline className="oc-map-line" points={pts} />
          <rect
            className="oc-map-label"
            x={c.box.x}
            y={c.box.y}
            width={c.box.w}
            height={c.box.h}
            rx="5"
          />
          <text
            className="oc-map-label-text"
            x={c.box.x + c.box.w / 2}
            y={c.box.y + c.box.h / 2 + 7}
            textAnchor="middle"
          >
            {c.name}
          </text>
          <circle
            className="oc-map-pulse"
            cx={dx}
            cy={dy}
            r="7"
            style={{ animationDelay: `${c.delay}s` }}
          />
          <circle
            className="oc-map-pulse oc-map-pulse-2"
            cx={dx}
            cy={dy}
            r="7"
            style={{ animationDelay: `${c.delay + 0.9}s` }}
          />
          <circle className="oc-map-dot" cx={dx} cy={dy} r="7" />
        </g>
      );
    })}
  </svg>
);

const Card = ({ card }) => {
  if (card.type === "quote") {
    return (
      <div className="oc-card oc-card-quote">
        <div className="oc-card-head">
          <span className="oc-icon-box oc-icon-box-glass">
            <img src={`${A}${card.icon}`} alt="" />
          </span>
          <h3>{card.title}</h3>
        </div>
        <p className="oc-quote">{card.quote}</p>
      </div>
    );
  }

  return (
    <div className={`oc-card ${card.highlight ? "oc-card-highlight" : ""}`}>
      <div className="oc-card-head">
        <span className={`oc-icon-box oc-icon-box-${card.iconBg}`}>
          <img src={`${A}${card.icon}`} alt="" />
        </span>
        <h3>{card.title}</h3>
      </div>

      {card.type === "chips" ? (
        <div className="oc-chips">
          {card.items.map((c, i) => (
            <span
              className={`oc-chip ${
                card.chipsWideFrom !== undefined && i >= card.chipsWideFrom
                  ? "oc-chip-wide"
                  : ""
              }`}
              key={c}
            >
              {c}
            </span>
          ))}
        </div>
      ) : (
        <ul className="oc-list">
          {card.items.map((it, i) => (
            <li key={it}>
              <img
                className="oc-bullet"
                src={`${A}${card.bullets ? card.bullets[i] : card.bullet}`}
                alt=""
              />
              <span>{it}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const Ourclub = () => {
  // Opens the same "Become a Member" join form used on the Join page
  const [isJoinOpen, setIsJoinOpen] = useState(false);

  return (
    <div className="oc-page">
      {/* Section 1 - Hero */}
      <section className="oc-hero">
        <h1 className="oc-hero-title">
          Where Professionals <span>Become Leaders</span>
        </h1>
        <button
          type="button"
          className="oc-hero-btn"
          onClick={() => setIsJoinOpen(true)}
        >
          Become a Member
          <img src={`${A}arrow _icon_get.png`} alt="" />
        </button>
      </section>

      {/* Sections 2 to 6 */}
      {CLUBS.map((club) => (
        <section
          key={club.id}
          className={`oc-section oc-section-${club.id} oc-theme-${club.theme}`}
        >
          <div className="oc-container">
            <span className="oc-number">{club.number}</span>

            <div className="oc-intro">
              <h2 className="oc-title">{club.title}</h2>
              {club.subtitle && <h4 className="oc-subtitle">{club.subtitle}</h4>}
              <span className="oc-tag">{club.tag}</span>
              <p className="oc-desc">{club.desc}</p>
            </div>

            <div className="oc-cards">
              {club.cards.map((card) => (
                <Card card={card} key={card.title} />
              ))}
            </div>
          </div>
        </section>
      ))}

      {/* Section 7 - Our Club Presence */}
      <section className="oc-pres">
        <div className="oc-pres-inner">
          <div className="oc-pres-left">
            <span className="oc-pres-tag">{PRESENCE.tag}</span>
            <h2 className="oc-pres-title">{PRESENCE.title}</h2>
            <p className="oc-pres-desc">{PRESENCE.desc}</p>

            <div className="oc-pres-cards">
              {PRESENCE.cards.map((c) => (
                <div
                  key={c.title}
                  className={`oc-pres-card ${c.dark ? "oc-pres-card-dark" : ""}`}
                >
                  <div className="oc-pres-card-head">
                    <img src={`${A}${PRESENCE.icon}`} alt="" />
                    <h3>{c.title}</h3>
                  </div>
                  <span className="oc-pres-count">{c.count}</span>
                  <p className="oc-pres-places">{c.places}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="oc-pres-right">
            <div className="oc-pres-map">
              <IndiaMap />
            </div>
          </div>
        </div>
      </section>

      {/* Join form popup (same as the Join page) */}
      <JoinModal
        isOpen={isJoinOpen}
        onClose={() => setIsJoinOpen(false)}
      />
    </div>
  );
};

export default Ourclub;